module.exports = __webpack_public_path__ + "assets/img/glace_fruit.f4b19ffe.png";